import { defineComponent, computed } from "vue";
import { o as omit } from "../../../vendor-2b2dbafd.mjs";
import { V as VaButton } from "../va-button/index-e7ff1275.mjs";
import { V as VaConfig } from "../va-config/VaConfig-594daf87.mjs";
import { e as extractComponentProps } from "../../utils/component-options/extract-component-options-6b96d215.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
import { u as useTextColor } from "../../composables/useTextColor-d6b2d8c3.mjs";
import { f as filterComponentProps } from "../../utils/component-options/filter-props-9727421a.mjs";
import { u as useBem } from "../../composables/useBem-33d80128.mjs";
const VaButtonProps = omit(extractComponentProps(VaButton), ["block", "gradient"]);
const _sfc_main = defineComponent({
  name: "VaButtonGroup",
  components: { VaConfig },
  props: {
    ...VaButtonProps,
    ...useComponentPresetProp,
    grow: { type: Boolean, default: false },
    gradient: { type: Boolean, default: false }
  },
  setup: (props) => {
    const { getColor, getGradientBackground } = useColors();
    const colorComputed = computed(() => getColor(props.color));
    const { textColorComputed } = useTextColor(colorComputed);
    const filteredProps = filterComponentProps(VaButtonProps);
    const buttonConfig = computed(() => ({
      VaButton: {
        ...filteredProps.value,
        ...props.gradient && {
          color: "#00000000",
          textColor: textColorComputed.value
        }
      }
    }));
    const computedClass = useBem("va-button-group", () => ({
      square: !props.round,
      grow: props.grow,
      small: props.size === "small",
      large: props.size === "large"
    }));
    const backgroundColor = computed(
      () => props.gradient ? getGradientBackground(colorComputed.value) : "transparent"
    );
    return { buttonConfig, computedClass, backgroundColor };
  }
});
export {
  _sfc_main as _
};

import '../../../VaButtonGroup.css';
//# sourceMappingURL=VaButtonGroup.vue_vue_type_script_lang-34129707.mjs.map
